import React, { Fragment } from 'react'
import { map, isNil } from 'lodash'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { Col, FormInputText, FormInputTextArea, Row, Tip } from 'camino-react'

import Alert from 'Components/Alert'
import NextSectionButtons from 'Components/Tickets/Form/Sections/NextSectionButtons'
import ServiceType from 'Components/Tickets/Form/Sections/Services/ServiceType'
import ServiceCategories from 'Components/Tickets/Form/Sections/Services/ServiceCategories'

function missingCategoryFields(ticket_type_id, clientId) {
  const fields = []

  isNil(ticket_type_id) && fields.push('a ticket type')
  isNil(clientId) && fields.push('a customer')

  return fields.join(' and ')
}

const TicketCreateFormSectionsService = ({
  hidden,
  serviceCategories,
  service_category_id,
  sub_category_id,
  priority_id,
  handleSelectChange,
  ticket_type_id,
  setFieldErrorClasses,
  setNextModalSection,
  title,
  description,
  setFieldValue,
  priorities,
  customer_contract_id,
  service_id,
  service_type,
  clientId,
  canSetPriority,
  currentUser,
  submitAction,
  submitButtonText,
  userManagementCategoryId
}) => {
  const priorityInfo = ['',
  `<b>P1</b> Business critical issue with no workaround, or a severe outage. The entire Service is unavailable, and all Users are affected <br>
  <b>P2</b> Degraded Service. The issue allows the Client to continue operating, but an important function of Service is unavailable. Users can operate, but there is a severe impact on performance <br>
  <b>P3</b> A Service or function is impacted, but not severely <br>
  <b>P4</b> A shortcoming with a Service or function, a request to make a change to a Service or a User request (JML) or permission changes`,
  `<b>P1</b> High priority person(s) service request or activity with a strict deadline <br>
  <b>P2</b> Core office request for information for upcoming (but not as strict) deadline <br>
  <b>P3</b> a request to make a change to a Service or a User request (JML) or permission changes <br>
  <b>P4</b> Request for information with no urgency associated
  `]

  if (!hidden) {
    const userHasntInputtedClient = !currentUser.guest_user && isNil(clientId) 

    if (isNil(ticket_type_id) || userHasntInputtedClient) {
      return (
        <Alert type="info">
          Please select {missingCategoryFields(ticket_type_id, clientId, currentUser)} to populate the service categories
        </Alert>
      )
    }
  }

  return (
    <div className={hidden ? 'hidden' : ''}>
      {serviceCategories !== 'hidden' && (
        <div>
          <ServiceCategories {...{
            guestServiceCategories: serviceCategories,
            service_category_id,
            clientId,
            sub_category_id,
            customer_contract_id,
            service_id,
            service_type,
            handleSelectChange,
            ticket_type_id,
            setFieldErrorClasses,
            currentUser,
          }} />

          {canSetPriority && (
            <Row>
              <Col>
                <label>
                  Priority <Tip content={priorityInfo[ticket_type_id]} />
                  <Select
                    className={setFieldErrorClasses('priority_id')}
                    value={priority_id}
                    onChange={option => handleSelectChange('priority_id', option)}
                    options={map(priorities, ({ name, id }) => ({ label: `P${name}`, value: id }))}
                    clearable={false}
                  />
                </label>
              </Col>
            </Row>
          )}

          <div>
            <label>
              Please describe your issue
            </label>
            <br />
          </div>
        </div>
      )}

      <div>
        <div className="row row--small-gutters row--bottom-spaced">
          <div className="col">
            <label htmlFor="ticket_title">
              Title
              <FormInputText
                value={title}
                onValue={text => setFieldValue('title', text)}
              />
            </label>
          </div>
        </div>

        <div className="row row--small-gutters row--bottom-spaced">
          <div className="col">
            <label htmlFor="ticket_description">
              Description
              <FormInputTextArea
                value={description}
                rows={5}
                onValue={text => setFieldValue('description', text)}
              />
            </label>
          </div>
        </div>
      </div>

      {currentUser.calligo_employee && (
        <NextSectionButtons setNextModalSection={() => setNextModalSection('Queues')} />
      ) || (
          <div className="form-section">
            <div className="form-section__actions">
              <button type="button" className="button button--outline form-section__action" onClick={() => { window.location.reload(true) }}>
                Cancel
              </button>
              <button onClick={submitAction} className="form-section__action button" type="button">
                {submitButtonText}
              </button>
            </div>
          </div>
        )}

    </div>
  )
}

TicketCreateFormSectionsService.defaultProps = {
  hidden: false,
  serviceCategories: []
}

TicketCreateFormSectionsService.propTypes = {
  hidden: PropTypes.bool,
  serviceCategories: PropTypes.array,
  service_category_id: PropTypes.number,
  sub_category_id: PropTypes.number,
  handleSelectChange: PropTypes.func.isRequired,
  setFieldErrorClasses: PropTypes.func.isRequired,
  setNextModalSection: PropTypes.func.isRequired
}

export default TicketCreateFormSectionsService
